/**
 *
 * @param url
 * @returns {boolean}
 */
function isRelativeUrl(url) {
    return !/^(?:[a-z]+:)?\/\//i.test(url);
}

function fullUrl(url) {
    if (isRelativeUrl(url)) {
        url = window.location.protocol + "//" + getDomainFromUrl(window.location.href) + url;
    }
    return url;
}

function getDomainFromUrl(url) {
    const parsedUrl = new URL(url);
    return parsedUrl.hostname;
}
console.log('common x2');
/**
 *
 * @param link
 * @returns {boolean}
 */
function isLinkOutbound(link) {
    const currentUrl = window.location.href;
    return getDomainFromUrl(currentUrl) !== getDomainFromUrl(link);
}

$(document).ready(function () {
    $('body').on('click', 'a', function (ev) {
        var linkData = $(this).data('track');
        var data = {
            action: '',
            label: ''
        }

        if (typeof trackingData != 'undefined' && typeof linkData != 'undefined') {
            data.action = linkData.action;
            data.label = linkData.label;
        }
        let link = $(this).attr('href');
        link = fullUrl(link)
        if (typeof link !== "undefined") {
            data.outbound = isLinkOutbound(link);
            data.locationInPage = linkData && linkData.locationInPage ? linkData.locationInPage : 'general';
            data.link_classes = $(this).attr('class')
            data.link_domain = getDomainFromUrl(link);
            data.destination = link;
            data.link_url = link;
            data.buttonText = $(this).text();
        }
        //ev.preventDefault();
        trackEvent(data, 'navigationClick');
        //return false;
        if ($(this).hasClass('SubNav__link') && $('body').hasClass('optimize-variant-1')) {
            $('.SubNav__linkItem, ul.SubNav_Cars').removeClass('is-active');
            $(this).parent().addClass('is-active');
            $('.SubNav__contentCars, ul.SubNav_Cars.nav-' + $(this).data('nav')).addClass('is-active');
            return false;
        }

        return true;
    });

});